import { useQuery, useQueryClient } from '@tanstack/react-query';

import { MyRobotManager, MyRobotUrls } from './MyRobotManager';
import { useRobotId } from './hooks';

export function useMyRobotPayloads() {
  const queryClient = useQueryClient();

  const { robotId } = useRobotId();
  const queryKey = [MyRobotUrls.GetMyRobotPayloads.url(robotId)];
  const { data: robotPayloads, isLoading } = useQuery({
    queryKey,
    queryFn: () => MyRobotManager.GetMyRobotPayloads(robotId),
    refetchInterval: 10 * 1000,
    initialData: [],
  });

  function refreshRobotPayloads() {
    return queryClient.invalidateQueries({ queryKey });
  }

  return { robotPayloads, refreshRobotPayloads, isLoading };
}
